import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { RepresentativeDto } from '../../../../../shared/models/auth.interfaces'

@Component({
    selector: 'app-dashboard-layout-sidebar-client',
    templateUrl: './dashboard-layout-sidebar-client.component.html',
    styleUrls: ['./dashboard-layout-sidebar-client.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardLayoutSidebarClientComponent {
    @Input() representative: RepresentativeDto | null = null
}
